module.exports = __webpack_public_path__ + "static/media/onboardingTours.5d6794cc.png";